import { AxiosResponse } from "axios";
import { call, put, select, takeLatest } from "redux-saga/effects";
import { AppService } from "src/services/app";
import { getBaseUrl } from "../selectors/features/app";
import {
  createStripeProductDbFailure,
  createStripeProductDbSuccess
} from "../slices/features/stripeProductDb";
import { RequestTypes } from "../types";

const appservice = new AppService();

function* createStripeProductDbSaga(action: any) {
  const { payload } = action;
  const { id, data } = payload;

  try {
    const baseUrl: string = yield select(getBaseUrl);

    const response: AxiosResponse<any> = yield call(
      appservice.createStripeProductDb,
      baseUrl,
      id,
      data
    );

    yield put(createStripeProductDbSuccess({ ...response }));

    let productsData = {};
    if (response.data) {
      productsData = response.data;
    }

    payload?.cbSuccess && payload?.cbSuccess(productsData);
  } catch (error: any) {
    const { statusCode, statusText } = error;
    yield put(createStripeProductDbFailure({ statusCode, statusText }));
  }
}

export function* watchCreateStripeProductDb() {
  yield takeLatest(
    RequestTypes.CREATE_STRIPE_PRODUCT_DB_REQUEST,
    createStripeProductDbSaga
  );
}
